import type { CloudGraphProjectEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI: CloudGraphProjectEntityAti[] = [
	'ati:cloud:graph:project',
];
